"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AVAILABLE_ATTRIBUTES_CACHE_TTL = void 0;
var light_data_store_1 = __importDefault(require("../Data/light-data-store"));
var merge_mapper_1 = require("../Data/merge-mapper");
var data_store_1 = __importDefault(require("../data-store"));
var storable_data_service_1 = __importDefault(require("../storable-data-service"));
var cached_item_1 = require("../utils/cached-item");
var task_managed_attributes_realtime_subscriptions_1 = __importDefault(require("./task-managed-attributes-realtime-subscriptions"));
var task_managed_attributes_service_1 = __importDefault(require("./task-managed-attributes-service"));
// exported for testing only
exports.AVAILABLE_ATTRIBUTES_CACHE_TTL = 1000 * 60 * 60; // 1 hour
var TaskManagedAttributesApi = /** @class */ (function () {
    function TaskManagedAttributesApi(session) {
        var _this = this;
        this.cachedAvailableAttributes = new cached_item_1.CachedItem({
            ttl: {
                ttlInMs: exports.AVAILABLE_ATTRIBUTES_CACHE_TTL
            }
        });
        this.dataStore = new data_store_1.default();
        var lightDataStore = new light_data_store_1.default();
        this.service = new task_managed_attributes_service_1.default(session);
        this.storableDataService = new storable_data_service_1.default(this.dataStore, function (managedAttribute) { return merge_mapper_1.mergeMapper.mergeIntoExisting(_this.dataStore, managedAttribute); }, [lightDataStore]);
        this.realtimeSubscriptions = new task_managed_attributes_realtime_subscriptions_1.default(session, this.dataStore, this.storableDataService);
        this.realtimeSubscriptions.updateStoreOnEvents(function (id) { return __awaiter(_this, void 0, void 0, function () {
            var _a, managedAttributes;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.loadByIds([id], { useCache: false })];
                    case 1:
                        _a = __read.apply(void 0, [_b.sent(), 1]), managedAttributes = _a[0];
                        return [2 /*return*/, managedAttributes];
                }
            });
        }); });
    }
    TaskManagedAttributesApi.prototype.get = function (id) {
        return this.getByIds([id])[0];
    };
    TaskManagedAttributesApi.prototype.getByIds = function (ids) {
        return this.storableDataService.getFromStores(ids);
    };
    TaskManagedAttributesApi.prototype.loadByIds = function (ids, commonOptions) {
        var _this = this;
        if (commonOptions === void 0) { commonOptions = { useCache: true }; }
        return this.storableDataService.loadMany('loadByIds', function (idsToLoad) { return __awaiter(_this, void 0, void 0, function () {
            var managedAttributes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.loadByIds(idsToLoad, commonOptions)];
                    case 1:
                        managedAttributes = _a.sent();
                        return [2 /*return*/, Object.entries(managedAttributes).map(function (_a) {
                                var _b = __read(_a, 2), id = _b[0], managedAttribute = _b[1];
                                managedAttribute.id = parseInt(id, 10);
                                return managedAttribute;
                            })];
                }
            });
        }); }, ids, commonOptions);
    };
    TaskManagedAttributesApi.prototype.getAvailableAttributes = function () {
        return __awaiter(this, void 0, void 0, function () {
            var attributes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        attributes = this.cachedAvailableAttributes.get();
                        if (!!attributes) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.service.getAvailableAttributes()];
                    case 1:
                        attributes = _a.sent();
                        this.cachedAvailableAttributes.set(attributes);
                        _a.label = 2;
                    case 2: return [2 /*return*/, attributes];
                }
            });
        });
    };
    TaskManagedAttributesApi.prototype.onUpdate = function (callback) {
        return this.realtimeSubscriptions.onUpdate(callback);
    };
    TaskManagedAttributesApi.prototype.resetAllListeners = function () {
        this.realtimeSubscriptions.resetAllListeners();
    };
    return TaskManagedAttributesApi;
}());
exports.default = TaskManagedAttributesApi;
//# sourceMappingURL=task-managed-attributes-api.js.map